import actions from '@devices/settings/device_settings/actions.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellytrv',
	friendly_name: 'TRV',
	family: 'thermostat',
	isPM: false,
	modes: {
		thermostat: {
			availableViews: ['advanced'],
			slider: false,
			channels: 1,
			notifications: ['offline', 'device_problem'],
			settings: [
				{
					title: 'sensor_settings',
					components: [
						{
							title: 'temperature_offset',
							component: 'temperature_offset_trv',
						},
						{ title: 'temperature_unit', component: 'temperature_unit' },
						{ title: 'open_window', component: 'open_window' },
					],
				},
				{
					title: 'schedule',
					components: [{ title: 'schedule', component: 'schedules_trv' }],
				},
				actions,
				{
					title: 'networks',
					components: [
						{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
						{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
						{ title: 'restrict_login', component: 'restrict_login' },
						{ title: 'mqtt', component: 'mqtt_gen_2' },
						{ title: 'cloud', component: 'cloud' },
					],
				},
				{
					title: 'application_settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{ title: 'pin_lock', component: 'pin_lock' },
					],
				},
				share,
				{
					title: 'settings',
					components: [
						{ title: 'boost', component: 'boost_time' },
						{ title: 'calibration', component: 'calibration_trv' },
						{ title: 'auto_temperature_control', component: 'auto_t_trv' },
						{ title: 'minimal_valve_position', component: 'min_valve_trv' },
						{ title: 'under_floor_heating', component: 'under_floor_heating' },
						{ title: 'display', component: 'display' },
						{ title: 'clog_prevention', component: 'clog_prevention' },
						{ title: 'force_close', component: 'force_close' },
						{ title: 'kids_protection', component: 'kids_protection' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
